<template>
  <main style="opacity: 0;">
    <div class="block">
      <Paragraph
        size="small"
        :text="structure[0].eyelet"
        class="block__eyelet"
        data-anim="fade"
      />
      <Counter
        number="03"
        data-anim="fade"
      />
      <div data-nav="team">
        <Title
          :size="structure[0].titleSize"
          :text="structure[0].title"
          data-anim="title"
          data-view="false"
          data-siblings
        />
      </div>

      <div class="block__content">
        <List :slots="slots" type="team">
          <a
            v-for="(person, index) in this.people"
            :key="index"
            :href="person.link"
            :slot="`slot-${index}`"
            :data-nav="person.id"
            :aria-label="person.title"
            :data-image="person.image"
            data-project="true"
            @click.prevent="goTo(person.link)"
            @mouseenter="hover"
            @mouseleave="hover"
          >
            <Paragraph
              size="small"
              :text="person.role"
              class="team__role"
              data-anim="fade"
              data-view="false"
            />

            <Title
              size="team"
              :text="person.title"
              data-anim="title"
              data-view="false"
            />
          </a>
        </List>
      </div>

    </div>
  </main>
</template>

<script>

import hades from '@/scripts/hades';
import utils from '@/scripts/utils';
import { hovers } from '@/assets/animations';

import Counter from '@/components/text/Counter.vue';
import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import List from '@/components/text/List.vue';
import BulletList from '@/components/BulletList.vue';
import BlockText from '@/components/BlockText.vue';

export default {
  name: 'People',

  components: {
    Counter,
    Title,
    Paragraph,
    BulletList,
    List,
    BlockText,
  },

  computed: {
    structure() {
      const data = this.$store.state.firebase.team;
      const { lang } = this.$store.state;
      const structure = data.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        s.push(Object.assign(structure[key].data, {
          component: this.$store.state.settings.components[structure[key].component].component
        }));
      });
      return s;
    },

    extra() {
      const s = this.structure;
      s.splice(0, 1);
      return s;
    },

    // customText() {
    //   const text = this.structure[0].text.replace('Michele Denegri', '<span class="interactive-span" data-image="/static/images/michele-denegri.jpg" alt="Michele Denegri">Michele Denegri</span>');
    //   return text;
    // },

    people() {
      const { childrens } = this.$store.state.firebase.team;
      const { lang } = this.$store.state;
      const pathLang = lang === 'it' ? 'path' : 'pathEn';
      const p = [];
      Object.keys(childrens).forEach((key) => {
        const peopleStructure = childrens[key].structure[this.$store.state.lang];
        const s = [];
        Object.keys(peopleStructure).forEach((pkey) => {
          if (peopleStructure[pkey].component === 'TeamDetails') {
            s.push(peopleStructure[pkey].data);
          }
        });
        p.push({
          id: childrens[key][pathLang].substr(1),
          title: s[0].title,
          role: s[0].role,
          image: s[0].image,
          link: lang === 'it' ? `/${lang}/team${childrens[key].path}` : `/${lang}/team${childrens[key].pathEn}`,
          order: childrens[key].order,
        });
      });

      p.sort((a, b) => a.order - b.order);
      return p;
    },

    slots() {
      const s = [];
      this.people.forEach((key, index) => {
        s.push(`slot-${index}`);
      });
      return s;
    },
  },

  data() {
    return {
      show: false,
      hoverAnim: {},
      width: '100%',
      prevAmount: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const discover = this.$el.querySelector('.discover');
      const line = this.$el.querySelector('.list__line');
      const widthD = discover.getBoundingClientRect().width;
      const widthL = line.getBoundingClientRect().width;
      this.width = widthL - widthD - 20;

      this.imageTimeline = hovers.get('pointer-image')(this.$root.$children[0].$el);
      const interactive = Array.from(this.$el.querySelectorAll('[data-project="true"]'));
      
      if (!utils.isTouchDevice()) {
        interactive.forEach(i => i.addEventListener('mouseenter', this.showImage));
        interactive.forEach(i => i.addEventListener('mouseleave', this.hideImage));
      } else {
        // interactive.forEach(i => i.addEventListener('touchstart', this.showImage));
        // interactive.forEach(i => i.addEventListener('touchend', this.hideImage));
      }
      window.addEventListener('hades-scroll', this.preventImage);
    });
  },

  beforeDestroy() {
    const interactive = Array.from(this.$el.querySelectorAll('[data-project="true"]'));

    if (!utils.isTouchDevice()) {
      interactive.forEach(i => i.removeEventListener('mouseenter', this.showImage));
      interactive.forEach(i => i.removeEventListener('mouseleave', this.hideImage));
    } else {
      // interactive.forEach(i => i.removeEventListener('touchstart', this.showImage));
      // interactive.forEach(i => i.removeEventListener('touchend', this.hideImage));
    }

    window.removeEventListener('hades-scroll', this.preventImage);
  },

  methods: {
    hover(event) {
      if (utils.isTouchDevice()) return;
      const dir = event.type === 'mouseenter';
      const dataNav = event.target.dataset.nav;

      if (dir) {
        if (this.hoverAnim[dataNav] === undefined) this.hoverAnim[dataNav] = hovers.get('project')(event.target.parentNode, this.width);
        this.hoverAnim[dataNav].play();
      } else {
        this.hoverAnim[dataNav].reverse();
      }
    },

    goTo(link) {
      this.hideImage();
      this.$goTo(link, 'parent-child');
    },

    showImage(event) {
      const url = event.currentTarget.dataset.image;
      const picture = document.querySelector('.pointer__image__picture');

      this.imageTimeline.play(0);
      picture.style.backgroundImage = `url('${url}')`;

      this.show = true;
    },
    hideImage() {
      this.show = false;
      this.imageTimeline.reverse();
    },
    preventImage(event) {
      if (this.show && Math.abs(hades.ref.amount.y - this.prevAmount) > 100) this.imageTimeline.reverse();
      this.prevAmount = hades.ref.amount.y;
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__content {
    @include mq($and: $is-touch-device) {
      user-select: none;
    }

    p {
      margin-top: rem(100px);
    }
  }

  &__notes {
    padding-top: rem(100px);
    p {
      margin-top: rem(60px);
    }
  }
}

.team {
  position: relative;

  &__role {
    position: absolute;
    margin-top: rem(-50px);
  }
}
</style>
